module.exports = __webpack_public_path__ + "static/author-e8034301a1d2c442225b02537df2b479.png";